import { Modal } from "antd";
import styled from "styled-components";

export const CommonModalStyle = styled(Modal)`
  .ant-modal-content {
    background-color: ${({ theme }) => theme.custom?.background?.main || '#ffffff'};
  }

  .ant-modal-title {
    background-color: ${({ theme }) => theme.custom?.background?.main || '#ffffff'};
    color: ${({ theme }) => theme.custom?.primary?.dark || '#1a4fd9'};
  }
`;
